<section class="bg-white py-20 md:py-24">
  <div class="mx-auto max-w-7xl px-4 sm:px-5 md:px-0">
    <div class="mx-auto max-w-4xl text-center">
      <p class="text-sm font-semibold uppercase tracking-[0.2em] text-blue-700 font-['Inter']">
        Sempre um passo à frente
      </p>
      <h2 class="mt-4 text-4xl font-extrabold leading-tight text-gray-900 font-['Inter'] md:text-5xl">
        Nunca perca a oportunidade certa
      </h2>
      <p class="mx-auto mt-5 max-w-3xl text-lg font-normal leading-relaxed text-gray-500 sm:text-xl font-['Inter']">
        Leilão é questão de tempo. A Casato Brasil lembra você quando o leilão de um imóvel favoritado está chegando.
      </p>
    </div>

    <div class="mt-14 grid grid-cols-1 gap-6 lg:grid-cols-2">
        <article class="flex gap-5 rounded-lg border border-blue-100 bg-white p-6 shadow-[0px_12px_34px_rgba(37,99,235,0.08)] md:p-8">
          <div class="inline-flex h-14 w-14 shrink-0 items-center justify-center rounded-xl bg-blue-50 text-blue-700">
            <svg class="h-7 w-7" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m21 21-4.35-4.35M10.8 18a7.2 7.2 0 1 1 0-14.4 7.2 7.2 0 0 1 0 14.4Z"/>
            </svg>
          </div>
          <div>
            <h3 class="text-xl font-bold leading-snug text-gray-900 font-['Inter'] md:text-2xl">
              Alertas de busca salva
            </h3>
            <p class="mt-3 text-base font-normal leading-relaxed text-gray-500 font-['Inter'] md:text-lg">
              Salve seus filtros e seja avisado assim que um imóvel novo combinar com o que você procura, antes da concorrência ver.
            </p>
            <p class="mt-4 inline-flex items-center gap-2 text-sm font-medium leading-relaxed text-gray-500 font-['Inter'] md:text-base">
              <svg class="h-5 w-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16v12H4V6Zm0 1 8 6 8-6"/>
              </svg>
              No seu e-mail <span class="text-gray-900">· WhatsApp em breve</span>
            </p>
          </div>
        </article>

        <article class="flex gap-5 rounded-lg border border-blue-100 bg-white p-6 shadow-[0px_12px_34px_rgba(37,99,235,0.08)] md:p-8">
          <div class="inline-flex h-14 w-14 shrink-0 items-center justify-center rounded-xl bg-blue-50 text-blue-700">
            <svg class="h-7 w-7" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.8 4.6a5.4 5.4 0 0 0-7.6 0L12 5.8l-1.2-1.2a5.4 5.4 0 1 0-7.6 7.6L12 21l8.8-8.8a5.4 5.4 0 0 0 0-7.6Z"/>
            </svg>
          </div>
          <div>
            <h3 class="text-xl font-bold leading-snug text-gray-900 font-['Inter'] md:text-2xl">
              Acompanhamento de imóvel
            </h3>
            <p class="mt-3 text-base font-normal leading-relaxed text-gray-500 font-['Inter'] md:text-lg">
              Favorite um imóvel e receba aviso quando o leilão estiver se aproximando.
            </p>
            <p class="mt-4 inline-flex items-center gap-2 text-sm font-medium leading-relaxed text-gray-500 font-['Inter'] md:text-base">
              <svg class="h-5 w-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16v12H4V6Zm0 1 8 6 8-6"/>
              </svg>
              No seu e-mail <span class="text-gray-900">· WhatsApp em breve</span>
            </p>
          </div>
        </article>
    </div>

    <div class="mt-8 grid grid-cols-1 gap-5 lg:grid-cols-2">
        <article class="rounded-lg border border-blue-100 bg-white p-5 shadow-[0px_12px_34px_rgba(37,99,235,0.08)]">
          <div class="flex gap-4">
            <div class="relative inline-flex h-14 w-14 shrink-0 items-center justify-center rounded-xl bg-blue-50 text-blue-700">
              <span class="absolute -right-0.5 -top-0.5 h-3 w-3 rounded-full bg-green-500 ring-4 ring-white"></span>
              <svg class="h-7 w-7" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 10.5 12 4l8 6.5V20H4v-9.5Z"/>
              </svg>
            </div>
            <div class="min-w-0 flex-1">
              <div class="flex items-start justify-between gap-4">
                <h3 class="text-lg font-bold leading-tight text-gray-900 font-['Inter']">
                  Novo imóvel no seu alerta
                </h3>
                <p class="shrink-0 text-sm font-normal text-gray-400 font-['Inter']">agora</p>
              </div>
              <p class="mt-1 text-base font-normal leading-relaxed text-gray-500 font-['Inter']">
                Apartamento · São Paulo, SP · 37% abaixo da avaliação
              </p>
              <span class="mt-3 inline-flex rounded-lg bg-blue-50 px-3 py-1 text-sm font-semibold text-blue-700 font-['Inter']">
                Busca: SP · até R$ 250 mil
              </span>
            </div>
          </div>
        </article>

        <article class="rounded-lg border border-blue-100 bg-white p-5 shadow-[0px_12px_34px_rgba(37,99,235,0.08)]">
          <div class="flex gap-4">
            <div class="relative inline-flex h-14 w-14 shrink-0 items-center justify-center rounded-xl bg-blue-50 text-blue-700">
              <span class="absolute -right-0.5 -top-0.5 h-3 w-3 rounded-full bg-green-500 ring-4 ring-white"></span>
              <svg class="h-7 w-7" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 10.5 12 4l8 6.5V20H4v-9.5Z"/>
              </svg>
            </div>
            <div class="min-w-0 flex-1">
              <div class="flex items-start justify-between gap-4">
                <h3 class="text-lg font-bold leading-tight text-gray-700 font-['Inter']">
                  Leilão chegando
                </h3>
                <p class="shrink-0 text-sm font-normal text-gray-400 font-['Inter']">há 2h</p>
              </div>
              <p class="mt-1 text-base font-normal leading-relaxed text-gray-500 font-['Inter']">
                O leilão do seu imóvel favorito está chegando!
              </p>
              <span class="invisible mt-3 inline-flex rounded-lg bg-slate-50 px-3 py-1 text-sm font-semibold text-gray-600 font-['Inter']" aria-hidden="true">
                Placeholder
              </span>
            </div>
          </div>
        </article>
    </div>
  </div>
</section>
